import React, { useEffect, useState } from "react";
import { getUsers } from "../../services/user.services";
import { getAllTeams } from "../../services/team.services";
import { getAllLogs } from "../../services/gameLog.services";
import "./featuredInfo.css";
import { ArrowDownward, ArrowUpward } from "@material-ui/icons";

export default function FeaturedInfo(props) {
  const [allTeamsData, setAllTeamsData] = useState(null);
  const [allLogsData, setAllLogsData] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fnt = async () => {
      try {
        setLoading(true);
        const response = await getUsers(
          JSON.parse(sessionStorage.getItem("myData"))
        );
        console.log("user list successfull =====>>>", response.data);
        setUserData(response.data);
      } catch (error) {
        console.log("errorrrrrrr in all user list", error);
      } finally {
        setLoading(false);
      }
    };
    fnt();
  }, []);

  useEffect(() => {
    const fnt = async () => {
      try {
        setLoading(true);
        const response = await getAllTeams(
          JSON.parse(sessionStorage.getItem("myData"))
        );
        console.log("team list successfull =====>>>", response.data);
        setAllTeamsData(response.data);
      } catch (error) {
        console.log("errorrrrrrr in all team list", error);
      } finally {
        setLoading(false);
      }
    };
    fnt();
  }, []);

  useEffect(() => {
    const fnt = async () => {
      try {
        setLoading(true);
        const response = await getAllLogs(
          JSON.parse(sessionStorage.getItem("myData"))
        );
        console.log("log list successfull =====>>>", response.data);
        setAllLogsData(response.data);
      } catch (error) {
        console.log("errorrrrrrr in all log list", error);
      } finally {
        setLoading(false);
      }
    };
    fnt();
  }, []);

  return (
    <div>
      <div className="featured">
        <div className="featuredItem">
          <div className="featuredTitle">
            <span>Number of Users</span>
          </div>
          <div className="featuredMoneyContainer">
            <span className="featuredMoney">{userData?.length}</span>
          </div>
        </div>
        <div className="featuredItem">
          <div className="featuredTitle">
            <span>Number of Teams</span>
          </div>
          <div className="featuredMoneyContainer">
            <span className="featuredMoney">{allTeamsData?.length}</span>
          </div>
        </div>
      </div>
      <div className="featured2">
        <div className="featuredItemBig">
          <div>
            <div className="featuredTitle">
              <span>Total Number of Games</span>
            </div>
          </div>
          <div className="featuredMoneyContainer">
            <span className="featuredMoney">{allLogsData?.length}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
